import { classnames } from "lib/helpers";
import { rootNamespace } from "config";
import { useContext } from "react";
import { TreeContext } from "pages/Editor";
import _ from "lodash";
import Label from "./Properties/components/Label";
// TODO: fix shared css
import "./Properties/properties.css";

export default function DocumentProperties() {
  const { pages, publish } = useContext(TreeContext);
  // issue #6
  const stylesheets = _.get(pages, "stylesheets", []);
  const onKeyDown = ({ keyCode, target }) => {
    if (keyCode === 13) {
      const stylesheet = target.value;
      if (stylesheet && !stylesheets.includes(stylesheet)) {
        publish(rootNamespace, "ADD_STYLESHEET", stylesheet);
        target.value = "";
      }
    }
  };
  const removeStylesheet = (link) => {
    return () => publish(rootNamespace, "REMOVE_STYLESHEET", link);
  };
  return (
    <div className="pr">
      <div className="gp">
        <div className="vc f">
          <input type="text" placeholder="Add stylesheet" {...{ onKeyDown }} />
        </div>
        <div className={classnames("sp", { t: stylesheets.length > 0 })}>
          {stylesheets.map((link, i) => {
            return (
              <div key={i} className="pr-t d" onClick={removeStylesheet(link)}>
                <div className="i">
                  <i className="fa fa-ban"></i>
                </div>
                <div className="p">{link}</div>
              </div>
            );
          })}
        </div>
      </div>
      <div>
        <Label title="Onload">
          <button
            className="btn"
            onClick={() => publish(rootNamespace, "SHOW_EDITOR")}
          >
            Set action
          </button>
        </Label>
      </div>
    </div>
  );
}
